import React from "react";
import DonutChart from "react-donut-chart";
import "../../styles/global.scss";

const ReactDonutChart = ({ data = [] }) => {
  const colors = [
    "#FF9680",
    "#FF6F92",
    "#E228EB",
    "#AC64FF",
    "#66EFFF",
    "#76B4FF",
    "#67C1FF",
    "#55DBFF",
    "#53FAFB",
    "#85FD95",
    "#ADFC6F",
    "#E0FF57",
    "#FFEE00",
    "#FFE550",
    "#FFD26B",
    "#FFA97C",
    "#966959",
    "#7794A1",
  ];

  const combineData = (set) => {
    let newSet = [];

    for (let i = 0; i < set.length; i++) {
      if (i < 12) {
        newSet.push(set[i]);
      } else if (i === 12) {
        newSet.push({ label: "Other", value: set[i].value });
      } else {
        newSet[12].value += set[i].value;
      }
    }

    return newSet;
  };

  return (
    <>
      {data ? (
        <DonutChart
          colors={colors}
          width={500}
          height={325}
          data={combineData(data)}
          innerRadius={0.5}
          outerRadius={0.7}
          className="legend-text - legend legend-innertext-label"
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default ReactDonutChart;
